import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-layout" }
const _hoisted_2 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoginModal = _resolveComponent("LoginModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Sidebar, {
      "is-authenticated": _ctx.isAuthenticated,
      onLogout: _ctx.handleLogout,
      onLogin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLoginModal = true))
    }, null, 8, ["is-authenticated", "onLogout"]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view, {
        onLogin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLoginModal = true))
      })
    ]),
    _createVNode(_component_LoginModal, {
      visible: _ctx.showLoginModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showLoginModal = false)),
      onSuccess: _ctx.onLoginSuccess
    }, null, 8, ["visible", "onSuccess"])
  ]))
}